import { IAuthorization } from "../interfaces/IVisitor";
import api from "../services/api/api";

class VisitorAPI 
{
    getByAutorizationId = async (autorizacaoId: string) => await api.get<IAuthorization>(`/Visitante/autorizacao/${autorizacaoId}`)
}

export default new VisitorAPI();